import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { initTelemetry, trackPageView } from '../lib/telemetry';

/**
 * Mounts once globally inside <BrowserRouter>. Initializes the telemetry
 * client and fires a `page_view` on every route change.
 */
const TelemetryTracker = () => {
  const location = useLocation();
  const lastPathRef = useRef(null);

  useEffect(() => { initTelemetry(); }, []);

  useEffect(() => {
    const key = location.pathname + location.search;
    if (lastPathRef.current === key) return;
    lastPathRef.current = key;
    trackPageView();
  }, [location]);

  return null;
};

export default TelemetryTracker;
